/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Resource, Resource$inboundSchema } from "./resource.js";

export type ListResourcesResult = {
  /**
   * The cursor to fetch results from
   */
  nextCursor?: string | undefined;
  /**
   * The list of resources
   */
  resources: Array<Resource>;
};

/** @internal */
export const ListResourcesResult$inboundSchema: z.ZodMiniType<
  ListResourcesResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    resources: z.array(Resource$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listResourcesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListResourcesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListResourcesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListResourcesResult' from JSON`,
  );
}
